import get from 'lodash/get';

export function getClickHandler(onClick, onDblClick, delay) {
  var timeoutID = null;
  delay = delay || 250;
  return function ({ event, rowData }) {
    if (event?.target.nodeName === "INPUT") return;

    if (!timeoutID) {
      timeoutID = setTimeout(function () {
        onClick({ rowData });
        timeoutID = null
      }, delay);
      event?.persist() 
    } else {
      timeoutID = clearTimeout(timeoutID);
      onDblClick({ rowData });
    }
  };
}


export function getColumnId(column) {
  return column.name
}

export function deriveHiddenColumns(columns, data) {
  return columns.filter((column) => {
    const accessor = getAccessor(column);
    return column.autoHide && !data.some(datum => get(datum, accessor))
  }).map(getColumnId);
}

export function getAccessor(column) {
  return `${column.name}.rendered`
}